<template>
  <div>
    <b-field label="Card Number"
    :type="type"
    :message="message">
      <b-input
          placeholder="Credit Card"
          v-model="value"
          v-cleave="masks.creditCard"
          icon="credit-card"
          @blur="setType"
          @input="clearType">
      </b-input>
    </b-field>
  </div>
</template>
<script>

import Cleave from 'cleave.js'
const cleave = {
    name: 'cleave',
    bind(el, binding) {
        const input = el.querySelector('input')
        input._vCleave = new Cleave(input, binding.value)
    },
    unbind(el) {
        const input = el.querySelector('input')
        input._vCleave.destroy()
    }
}

const re = /^(?:(?<Visa>4[0-9]{12}(?:[0-9]{3})?)|(?<MasterCard>5[1-5][0-9]{14})|(?<Discover>6(?:011|5[0-9]{2})[0-9]{12})|(?<AMEX>3[47][0-9]{13})|(3(?:0[0-5]|[68][0-9])[0-9]{11})|(?<Diners>(?:2131|1800|35[0-9]{3})[0-9]{11}))$/

  export default {

      directives: { cleave },
      name: 'creditCardInput',
      data() {
        return {
          type: null,
          masks: {
              creditCard: { creditCard: true },
          },
          value: '',
          message: '',
          company: null
        }
      },
      methods: {
        setType() {
          var str = this.value
          str = str.replace(/\s/g, '');
          var match = str.match(re)
          var valid = this.luhn(str)
          if (valid && (str.length == 15 || str.length == 16) && match) {
            this.type = 'is-success'

            var companyTemp = null
            for (var key in match.groups) {
              if (match.groups[key]){
                companyTemp = key
              }
            }
            this.company = companyTemp
            this.message = 'Valid '+ this.company + ' Number'
            this.$emit('input', {num: this.value, code: this.cardCode(this.company)})
          }
          else {
            this.type = 'is-danger'
            this.message = 'Invalid Credit Card Number'
            this.$emit('input', null)
          }

        },
        clearType() {
          this.type = null
          this.message = ''
          this.$emit('input', null)
        },
        luhn(cardnumber) {
          // Build an array with the digits in the card number
          var digits = cardnumber.split('');
          for (var i = 0; i < digits.length; i++) {
            digits[i] = parseInt(digits[i], 10);
          }
          // Run the Luhn algorithm on the array
          var sum = 0;
          var alt = false;
          for (i = digits.length - 1; i >= 0; i--) {
            if (alt) {
              digits[i] *= 2;
              if (digits[i] > 9) {
                digits[i] -= 9;
              }
            }
            sum += digits[i];
            alt = !alt;
          }
          // Check the result
          return (sum % 10 == 0)
        },

        onInput(event) {
            this.rawValue = event.target._vCleave.getRawValue()
            this.value = event.target._vCleave.getFormattedValue()
        },

        cardCode(val) {
          var codes = {
            'Visa': 'VI',
            'MasterCard': 'CA',
            'AMEX':  'AX',
            'Discover': 'DS',
            'Diners': 'DC'

          }
          return codes[val]
        }

      }
  }
</script>
